type Format='bold'|'italic'|'underline';
type Shortcut=Pick<KeyboardEvent,'key'|'code'|'metaKey'|'ctrlKey'|'altKey'|'shiftKey'|'isComposing'>;
export function formattingShortcut(event:Shortcut):Format|null {
 if(event.isComposing||event.altKey||event.shiftKey||event.metaKey===event.ctrlKey)return null;
 const keys:Record<string,Format|undefined>={b:'bold',i:'italic',u:'underline'};
 return keys[event.key.toLowerCase()]??({KeyB:'bold',KeyI:'italic',KeyU:'underline'} as const)[event.code as 'KeyB'|'KeyI'|'KeyU']??null;
}
